import { useTranslation } from 'next-i18next'
import { Fade } from 'react-awesome-reveal'

import Park from '@/components/sections/Park'
import CustomReveal from '@/components/common/CustomReveal'

import { Container, TitleContainer } from './Parking.styled'

function Parking() {
  const { t } = useTranslation('navipay')

  return (
    <Container id="park-section">
      <CustomReveal>
        <TitleContainer text={t('park')} />
      </CustomReveal>
      <Fade>
        <Park />
      </Fade>
    </Container>
  )
}

export default Parking
